<template>
  <div>
    <button v-if="isOpen" class="fixed inset-0 hidden w-full h-full cursor-default md:block" tabindex="-1" @click="close"></button>

    <nav class="bg-blue-brand-700">
      <div class="mx-auto max-w-8xl sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16 px-4 sm:px-0">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <a :href="$router.options.base">
                <img class="hidden w-16 h-16" :src="require('../../assets/logo.png')" alt="Credencial digital del afiliado" />
                <img :src="require('../../assets/tipografico-provincia-buenos-aires.png')" alt="Credencial digital del afiliado" />
              </a>
            </div>

            <div class="hidden md:block">
              <div class="flex items-baseline ml-2"></div>
            </div>
          </div>

          <NavbarProfileDesktop @toggle="toggle" :is-open="isOpen" :user="user" />

          <HamburgerMenuMobile @toggle="toggle" :is-open="isOpen" />
        </div>
      </div>

      <NavbarProfileMobile :user="user" :is-open="isOpen" />
    </nav>
  </div>
</template>

<script>
import NavbarProfileDesktop from './NavbarProfileDesktop'
import NavbarProfileMobile from './NavbarProfileMobile'
import HamburgerMenuMobile from './HamburgerMenuMobile'
import { mixins } from '@colescba/componentes-web'

export default {
  components: { NavbarProfileDesktop, NavbarProfileMobile, HamburgerMenuMobile },

  mixins: [mixins.HasNavbarDropdown],

  props: {
    user: { type: Object, required: true },
  },
}
</script>
